// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeStripsStripUnlockBody = {
  poolId: string;
  eventId: string;
  stripNumber: number;
};

export type typeStripsStripUnlockOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { stripNumber: number; removedWinnerCount: number };
};

export type typeStripsStripUnlockOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsStripUnlockOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsStripUnlockOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaStripsStripUnlockBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    eventId: { type: "string", maxLength: 3000, minLength: 1 },
    stripNumber: { type: "integer" },
  },
  required: ["poolId", "eventId", "stripNumber"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createStripsStripUnlock(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaStripsStripUnlockBody);
  }

  return async function postStripsStripUnlock(
    payload: typeStripsStripUnlockBody,
  ): Promise<typeStripsStripUnlockOutput200 | typeStripsStripUnlockOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postStripsStripUnlock" failed before calling the network. #fda2d8e157ec`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#fda2d8e157ec" },
        },
        data: null,
      } as typeStripsStripUnlockOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/strips/strip-unlock`,
      httpMethod: "POST",
      options,
    })) as typeStripsStripUnlockOutput200 | typeStripsStripUnlockOutput400;
  };
}
